export const DECRYPT_REQUEST = "DECRYPT_REQUEST";
export const DECRYPT_SUCCESS = "DECRYPT_SUCCESS";
export const DECRYPT_FAILED = "DECRYPT_FAILED";